import { useState, useEffect } from 'react';
import { parseFrontmatter } from '../lib/frontmatter';

/**
 * Fetches and parses a markdown file from /public.
 * @param {string} publicPath - e.g. '/content/about.md'
 */
export function useMarkdown(publicPath) {
  const [state, setState] = useState({ frontmatter: {}, content: '', loading: true, error: null });

  useEffect(() => {
    if (!publicPath) return;
    let cancelled = false;

    setState((s) => ({ ...s, loading: true, error: null }));

    fetch(publicPath)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load ${publicPath}: ${res.status}`);
        return res.text();
      })
      .then((text) => {
        if (cancelled) return;
        const { frontmatter, content } = parseFrontmatter(text);
        setState({ frontmatter, content, loading: false, error: null });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({ frontmatter: {}, content: '', loading: false, error: err.message });
      });

    return () => { cancelled = true; };
  }, [publicPath]);

  return state;
}
